module.exports = __webpack_public_path__ + "static/media/www.dobracena.rs.16c815cb.png";